import { render } from "./FolderItem.vue?vue&type=template&id=004b54e0&scoped=true"
import script from "./FolderItem.vue?vue&type=script&lang=js"
export * from "./FolderItem.vue?vue&type=script&lang=js"

import "./FolderItem.vue?vue&type=style&index=0&id=004b54e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-004b54e0"]])

export default __exports__